import { Avatar, Box, Typography } from "@mui/material";
import { useEffect, useState, forwardRef, useImperativeHandle } from "react";
import { getAvatarColor, getAvatarInitials } from "../../utils/utils";

const MentionList = forwardRef(({ items, command }: any, ref) => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const selectItem = (index: number) => {
    const item = items[index];
    if (item) {
      command({
        id: item.id,
        label: item.name,
      });
    }
  };

  const onKeyDown = ({ event }: any) => {
    if (event.key === "ArrowDown") {
      setSelectedIndex((prev) => (prev + 1) % items.length);
      return true;
    }

    if (event.key === "ArrowUp") {
      setSelectedIndex((prev) =>
        (prev - 1 + items.length) % items.length
      );
      return true;
    }

    if (event.key === "Enter") {
      selectItem(selectedIndex);
      return true;
    }

    return false;
  };

  // 👇 expose to tippy renderer
  useImperativeHandle(ref, () => ({
    onKeyDown,
  }));

  useEffect(() => {
    setSelectedIndex(0);
  }, [items]);

  return (
  <Box className="mention-dropdown">
    {items.length === 0 ? (
      <Box className="mention-row no-results">
        <Typography variant="body2" color="text.secondary">
          No Results Found
        </Typography>
      </Box>
    ) : (
      items.map((user: any, index: number) => (
        <Box
          key={user.id}
          className={`mention-row ${
            index === selectedIndex ? "active" : ""
          }`}
          onMouseEnter={() => setSelectedIndex(index)}
          onClick={() => selectItem(index)}
        >
          <Avatar
            src={user.pictureUrl}
            alt={user.fullName || user.email || "Unknown Assignee"}
            sx={{ width: 24, height: 24, fontSize: "12px",
              bgcolor: !user.pictureUrl ? getAvatarColor(user?.email || user?.fullName) : undefined,
             }}
          >
            {!user?.pictureUrl && getAvatarInitials(user?.name || user?.email)}
          </Avatar>

          <Typography variant="body2">
            {user.name}
          </Typography>
        </Box>
      ))
    )}
  </Box>
);
});

export default MentionList;
